export default __webpack_public_path__ + "static/media/Traffic-Monitoring.189745c6.jpg";